import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWC505F1 (銷貨退回單核准)
// ============================================================

export interface ApprovalCandidate {
  fc130_01: string; // 退回單號
  fc130_10: string; // 出貨單號
  fc130_11: string; // 退回日期
  fc130_12: string; // 客戶代號
  fc130_13: string; // 退回金額
  fc130_80: string; // 核准狀態
  fc130_91: string; // 建單員工代號
}

export interface QueryResponse {
  items: ApprovalCandidate[];
  total: number;
}

export interface ApproveResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwc505Api = {
  /** Query sales return order candidates eligible for approval */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwc505/candidates', { params });
    return res.data;
  },

  /** Execute batch approval for selected sales return orders */
  async approve(items: string[]): Promise<ApproveResponse> {
    const res = await apiClient.post('/api/pwc505/approve', { items });
    return res.data;
  },
};
